module.exports = __webpack_public_path__ + "static/media/eyeAdd.e1268917.svg";